import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
interface HeroSectionProps {
  onScrollToPurchase: () => void;
}
export function HeroSection({
  onScrollToPurchase
}: HeroSectionProps) {
  const benefits = ['Material teórico completo por nivel', 'Más de 500 actividades listas para usar', 'Planificación anual de clases', 'Diapositivas preparadas para explicar procesos históricos'];
  return <section className="bg-white py-6 md:py-10 px-4" data-id="element-92">
      <div className="max-w-4xl mx-auto text-center" data-id="element-93">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-[#586880] font-bold tracking-wider uppercase md:text-base mb-2 text-[11.5px]" data-id="element-94">
          Para docentes de Historia de nivel secundario
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-3xl md:text-5xl font-extrabold text-[#424E60] leading-tight mb-4 uppercase" data-id="element-95">
          Manual Académico de Historia para Docentes
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2
      }} className="max-w-xl mx-auto mb-6 relative" data-id="element-96">
          <img src="https://cdn.magicpatterns.com/uploads/66NpyQbtLq1RdgHMo7bxyr/Diseno_sin_titulo_(4).png" alt="Manual Académico Historia" className="w-full h-auto rounded-xl shadow-2xl" data-id="element-97" />
        </motion.div>

        <motion.h3 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="text-lg md:text-xl font-bold text-[#424E60] mb-4" data-id="element-98">
          La colección de Historia que puede ahorrarte decenas de horas de
          planificación este año
        </motion.h3>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="text-base md:text-lg text-[#424E60] mb-6 max-w-3xl mx-auto leading-relaxed" data-id="element-99">
          Material completo para enseñar Historia de 1° a 5° año de secundaria,
          con contenidos, actividades, planificación y diapositivas listas para
          usar.
          <br data-id="element-100" />
          <br data-id="element-101" />
          Empieza el año con gran parte de tu trabajo docente ya organizado.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="bg-[#F4F4F2] rounded-xl p-5 md:p-6 text-left max-w-2xl mx-auto border border-[#E2DED6]" data-id="element-102">
          <ul className="space-y-3" data-id="element-103">
            {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-104">
                <CheckCircle2 className="text-[#4A7C59] shrink-0 mt-0.5" size={20} data-id="element-105" />
                <span className="text-[#424E60] font-bold text-base md:text-lg" data-id="element-106">
                  {benefit}
                </span>
              </li>)}
          </ul>

          <div className="mt-6" data-id="element-107">
            <CTAButton onClick={onScrollToPurchase} data-id="element-108">
              Acceder a la colección completa
            </CTAButton>
          </div>
        </motion.div>
      </div>
    </section>;
}